const getUser = state => state.auth.user;
const getToken = state => state.auth.token;

export { getUser, getToken };
